module.exports = __webpack_public_path__ + "static/media/MK.d705bea2.svg";